import { Carousel_CoreInit } from '../core'
import { carouselConfigs } from './carousel-config'

const favorites = {
  id: undefined,
  favorite_items: [],
  history_items: undefined,
  history_html: undefined,

  stringRandom(length) {
    const characters = 'abdefil012345679'
    let result = ''
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },

  generateFavoritesUid() {
    let string = ''
    while (string.length < 32) {
      string += this.stringRandom(Math.floor(Math.random() * (16 - 4 + 1)) + 4)
      string += '-'
    }
    string = string.slice(0, -1)
    if (string.length < 32) {
      string += this.stringRandom(1)
    }
    return string.substring(0, 32).toLowerCase()
  },

  add(content_uid, response) {
    if (!this.favorite_items.includes(content_uid)) {
      this.favorite_items.push(content_uid)
    }
  },

  remove(content_uid) {
    this.favorite_items = this.favorite_items.filter(item => item !== content_uid)
  },

  has(content_uid) {
    return this.favorite_items.includes(content_uid)
  },

  loadFavorites() {
    if (!this.id) return

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_favorites_list',
        'list_uid': this.id,
        'language': xnumeric_l10n.LANGUAGE,
      },
      success: (response) => {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response

          if (data.list_uid && data.list_uid !== this.id) {
            this.id = data.list_uid
            localStorage.setItem('favorites_id', this.id)
            this.setCookie('favorites_list_uid', this.id, 365)
          }
          this.favorite_items = data.items || []
          this.buttons()
        } catch(e) {
          this.favorite_items = []
        }
      },
    })
  },

  updateFavoriteCount() {
    const count = $.mlmi.favorites.favorite_items.length
    $('.btn-icon--heart').attr('data-count', count)
  },

  buttons(scope) {
    if (scope == undefined) {
      scope = document
    }
    $(scope).find('button.favorite__toggle').each(function() {
      $(this).FavoriteButton()
    })
  },

  page() {
    if ($('.favorites-page').length) {
      $('.favorites-grid').FavoritesPage()
    }
  },

  history() {
    if ($('.history-products').length) {
      let history = $('<div>').html(this.history_html),
      current_uid = $('.product-header .favorite__toggle').data('content-uid'),
      products = history.find('.card-infinite')
      let productsCounter = 0

      if (products.length) {
        products.each(function(index, card) {
          if (productsCounter < 15) {
            if (current_uid && $(card).find('.favorite__toggle').data('content-uid') == current_uid) {
              return
            }
            productsCounter++
            let gridItem = $('<div>').addClass('grid__item carousel__slide swiper-slide').append(card)
            $('.history-products .grid').append(gridItem)
          }
        })
      }

      if (productsCounter > 0) {
        $('.carousel-placeholder').addClass('carousel swiper-container').removeClass('carousel-placeholder')
        Carousel_CoreInit(carouselConfigs, $('.history-products .carousel__container'))
        $('.no-history').hide()
        // $.mlmi.favorites.buttons($('.history-products'))
      } else {
        $('.history-products .grid').hide()
        if ($('.no-history').length) {
          $('.no-history').show()
        } else {
          $('.history-products').closest('.page-section').remove()
        }
      }
    }
  },

  hit() {
    if ($('.page-product').length) {
      var favorites = $.mlmi.favorites,
      content_uid = $('.product-header .favorite__toggle').data('content-uid'),
      content_index = favorites.history_items.indexOf(content_uid)
      if (favorites.history_items.indexOf(content_uid) !== -1) {
        favorites.history_items.splice(content_index, 1)
      }
      favorites.history_items.unshift(content_uid)
      if (favorites.history_items.length > 7) {
        favorites.history_items = favorites.history_items.slice(0, 7)
      }
      localStorage.setItem('history_items', JSON.stringify(favorites.history_items))
      $.ajax({
        url: '/favorites/',
        method: 'POST',
        data: {
          'action': 'recent',
          'list_uid': $.mlmi.favorites.id,
          'history_items': favorites.history_items,
          'language': xnumeric_l10n.LANGUAGE,
        },
        success: function(response) {
          $.mlmi.favorites.history_html = response
          localStorage.setItem('history_html', $.mlmi.favorites.history_html)
        },
      })
    }
  },

  setCookie(name, value, days) {
    let expires = ""
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax"
  },

  init() {
    if ('localStorage' in window) {
      this.id = localStorage.getItem('favorites_id')
      this.history_items = localStorage.getItem('history_items')
      this.history_html = localStorage.getItem('history_html')

      if (!this.id) {
        this.id = this.generateFavoritesUid()
        this.favorite_items = []
        this.history_items = []
        this.history_html = ''
        localStorage.setItem('favorites_id', this.id)
        localStorage.setItem('history_items', JSON.stringify(this.history_items))
        localStorage.setItem('history_html', this.history_html)
      } else {
        this.favorite_items = []
        this.history_items = this.history_items ? JSON.parse(this.history_items) : []
        this.history_html = this.history_html || ''

        if (!this.history_html) {
          localStorage.setItem('history_html', '')
        }
      }

      this.setCookie('favorites_list_uid', this.id, 365)
    }
    $.mlmi.favorites = this
    this.buttons()

    // If user is logged in and favorites are provided in footer, use them
    if (typeof mlmi_favorites !== 'undefined' && Array.isArray(mlmi_favorites)) {
      this.favorite_items = mlmi_favorites
      this.buttons()
    } else {
      this.loadFavorites()
    }

    this.history()
    this.hit()
    this.page()
    this.updateFavoriteCount()
  },
}

$.fn.FavoriteButton = function() {
  let self = this

  if (self.data('favorite-button')) {
    let button = self.data('favorite-button')
    if ($.mlmi.favorites.has(button.uid)) {
      button.toggle_on()
    } else {
      button.toggle_off()
    }
    return button
  }

  self.pressed = self.attr('aria-pressed') === 'true'
  self.uid = self.data('content-uid')

  self.add = function() {
    $.mlmi.favorites.add(self.uid)
    favorites.updateFavoriteCount()

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'add',
        'list_uid': $.mlmi.favorites.id,
        'content_uid': self.uid,
        'language': xnumeric_l10n.LANGUAGE,
      },
      success: function(response) {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response
          if (data && data.list_uid && data.list_uid !== $.mlmi.favorites.id) {
            $.mlmi.favorites.id = data.list_uid
            localStorage.setItem('favorites_id', data.list_uid)
            $.mlmi.favorites.setCookie('favorites_list_uid', data.list_uid, 365)

          }
        } catch(e) {
        }
      },
      error: function(error) {
        $.mlmi.favorites.remove(self.uid)
        self.toggle_off()
      },
    })
  }

  self.remove = function() {
    $.mlmi.favorites.remove(self.uid)
    favorites.updateFavoriteCount()

    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'remove',
        'list_uid': $.mlmi.favorites.id,
        'content_uid': self.uid,
      },
      success: function(response) {
        try {
          const data = typeof response === 'string' ? JSON.parse(response) : response
          if (data && data.list_uid && data.list_uid !== $.mlmi.favorites.id) {
            $.mlmi.favorites.id = data.list_uid
            localStorage.setItem('favorites_id', data.list_uid)
            $.mlmi.favorites.setCookie('favorites_list_uid', data.list_uid, 365)
          }
        } catch(e) {
        }
      },
      error: function(error) {
        $.mlmi.favorites.add(self.uid)
        self.toggle_on()
      },
    })
  }

  self.toggle_on = function() {
    self.pressed = true
    self.attr('aria-pressed', 'true')
  }

  self.toggle_off = function() {
    self.pressed = false
    self.attr('aria-pressed', 'false')
  }

  self.clicked = function(e) {
    e.preventDefault()
    e.stopPropagation()

    if (self.pressed) {
      self.toggle_off()
      self.remove()
      $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_off()
    } else {
      self.toggle_on()
      self.add()
      $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_on()
    }
  }

  return function() {
    self.on('click', self.clicked)
    if ($.mlmi.favorites.has(self.uid)) {
      self.toggle_on()
    } else {
      self.toggle_off()
    }
    self.data('favorite-button', self)
    return self
  }()
}

$.fn.FavoritesPage = function() {
  let self = this

  self.is_shared_list = self.data('list-id') ? true : false

  self.copy_link = function(e) {
    e.preventDefault()
    let target = $(this)
    self.original_text = target.find('span').html()
    let textarea = $('<textarea>')
    textarea.val(target.attr('href'))
    target.append(textarea)
    textarea.focus().select()
    document.execCommand("Copy")
    textarea.remove()
    target.find('span').html(xnumeric_l10n.COPIED_LINK)
    setTimeout(function() {
      target.find('span').html(self.original_text)
    }, 3200)
    return false
  }

  self.unfavorite = function(e) {
    e.preventDefault()
    e.stopPropagation()

    let button = $(this)
    let gridItem = button.closest('.grid__item')
    let card = button.closest('.card-favorite')
    let title = card.find('.card-favorite__title').text()

    // Get content-uid from grid item (we stored it there when building the grid)
    let contentUid = gridItem.data('content-uid')

    if (!contentUid) {
      console.error('No content-uid found on grid item')
      return
    }

    // Store original height for smooth animation
    let originalHeight = gridItem.outerHeight()

    // Fade out the card
    card.css('opacity', 1)
    gridItem.css('height', originalHeight + 'px')

    card.animate({ opacity: 0 }, 300, function() {
      // Hide the card and create undo notification
      card.hide()

      let undoMessage = xnumeric_l10n.REMOVING_FAVORITE.replace('%s', title)
      let undoHtml = `
        <div class="favorites-undo-notification" style="opacity: 0;">
          <span class="favorites-undo-notification__message">${undoMessage}</span>
          <button class="favorites-undo-notification__button"><span>${xnumeric_l10n.UNDO}</span></button>
        </div>
      `

      gridItem.append(undoHtml)

      let notification = gridItem.find('.favorites-undo-notification')

      // Calculate notification height
      let notificationHeight = notification.outerHeight()

      // Animate grid item height to notification height and fade in notification
      gridItem.animate({ height: notificationHeight }, 300)
      notification.animate({ opacity: 1 }, 300)

      //Set up timer for auto-remove (15 seconds)
      let removeTimer = setTimeout(function() {
        // Find the favorite toggle button and trigger its remove function
        let favoriteButton = card.find('button.favorite__toggle[data-content-uid="' + contentUid + '"]')

        if (favoriteButton.length) {
          let buttonInstance = favoriteButton.FavoriteButton()

          // Override the toggle_off behavior temporarily so it doesn't interfere with our animation
          let originalToggleOff = buttonInstance.toggle_off
          buttonInstance.toggle_off = function() {}

          // Call the existing remove function
          buttonInstance.remove()

          // Restore original toggle_off
          buttonInstance.toggle_off = originalToggleOff
        } else {
          // Fallback if no favorite button exists
          $.mlmi.favorites.remove(contentUid)
          favorites.updateFavoriteCount()
        }

        // Update all favorite buttons on the page
        $('body').find('button.favorite__toggle[data-content-uid="' + contentUid + '"]').each(function() {
          $(this).FavoriteButton().toggle_off()
        })

        // Fade out and animate height to 0, then remove
        notification.animate({ opacity: 0 }, 200)
        gridItem.animate({ height: 0 }, 300, function() {
          gridItem.remove()

          // Check if there are any favorites left in THIS favorites grid
          let remainingItems = $('.favorites-grid .grid--style--favorite .card-favorite').length

          if (remainingItems === 0) {
            $('.favorites-grid').hide()
            $('.no-favorites').css('opacity', 0).slideDown(400).animate({ opacity: 1 }, 400)
          }
        })
      }, 5000)

      // Store timer on the grid item
      gridItem.data('remove-timer', removeTimer)

      // Undo button handler
      notification.find('.favorites-undo-notification__button').on('click', function(e) {
        e.preventDefault()
        e.stopPropagation()

        // Clear the timer
        clearTimeout(gridItem.data('remove-timer'))

        // Fade out notification and restore card
        notification.animate({ opacity: 0 }, 200, function() {
          notification.remove()
          card.show().css('opacity', 0)
          gridItem.animate({ height: originalHeight }, 300)
          card.animate({ opacity: 1 }, 300)
        })
      })
    })
  }

  return function() {
    /* Favorites list */
    if (!self.is_shared_list) {
      self.attr('data-list-id', $.mlmi.favorites.id)
      $('.share-favorites').attr('href', $('.share-favorites').attr('href') + $.mlmi.favorites.id + '/')
      $('.share-favorites').removeClass('d-none').on('click', self.copy_link)
    }

    /* Load items */
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_page',
        'language': xnumeric_l10n.LANGUAGE,
        'list_uid': self.is_shared_list ? self.data('list-id') : $.mlmi.favorites.id,
      },
      success: function(response) {
        response = $('<div>').append(response)
        let favoritesCount = 0

        /* Products */
        response.find('.card-favorite').each(function() {
          let productCard = $(this).removeClass('fade-in')

          // Extract content-uid from favorite toggle button (if it exists)
          let contentUid = productCard.find('.favorite__toggle').data('content-uid')

          // Wrap title in header and add unfavorite button
          productCard.find('.card-favorite__title').wrap('<div class="card-favorite__header"></div>')
          let unfavoriteBtn = $('<button>').addClass('card-favorite__unfavorite').html('<i class="icon-check"></i>')
          productCard.find('.card-favorite__header').append(unfavoriteBtn)

          let gridItem = $('<div>').addClass('grid__item').append(productCard)

          // Store content-uid directly on the grid item for easy access
          if (contentUid) {
            gridItem.attr('data-content-uid', contentUid)
          }

          $('.favorites-grid .grid').append(gridItem)
          favoritesCount++
        })

        /* Show interface */
        if (favoritesCount) {
          $('.no-favorites').hide()
          $('.favorites-grid').show()
        } else {
          $('.no-favorites').show()
          $('.favorites-grid').hide()
        }

        /* Favorite buttons */
        favorites.buttons(self)

        /* Unfavorite button handlers */
        $('.card-favorite__unfavorite').on('click', self.unfavorite)
      },
    })
    return self
  }()
}

export default favorites
